module.exports = __webpack_public_path__ + "static/media/councillor.fb197cbb.jpg";